module.exports = __webpack_public_path__ + "img/finalOrder.aa660e49.svg";